import styled from "styled-components";

export const InvoiceTableContainer = styled.div`
  overflow-y: auto;
  table {
    thead {
      border-bottom: 1px solid #ececee;
      tr {
        background:  #FCFCFC;
        border:1px solid #ececee;
        th {
          padding-block: 20px;
          color: #000000;
          font-size: 16px;
          font-family: "latosemibold";
          padding-inline: 20px;
          white-space: nowrap;
          border:none;
        }
      }
    }
    tbody {
      border: 1px solid #ececee;
      .even-rows{
        background: #FCFCFC;
      }
      .odd-rows{
        background: #fff;
      }
      .set-border{
        border: 1px solid #ececee;
        border-bottom: 0;
      }
      tr {
        border: none;
        td {
          padding: 16px;
          font-size: 14px;
          font-family: "latoregular";
          border: 0;

          /* :first-child {
            font-family: "latosemibold";
          } */
        }
      }
    }
    .cancel-order {
      background: #ffbdbd;
      border-radius: 28px;
      color: #f42c2c;
      font-size: 14px;
      line-height: 17px;
      padding: 10px 20px;
      border: none;
      text-transform: capitalize;
    }
  }
  .expand-collapse-class{
        display: flex;
        border: none;
        h4{
            background: #005586;
            padding: 0px;
            width: 17px;
            border-radius: 50%;
            height: 16px;
            margin: 5px 0px 0px 11px;
            cursor: pointer;
            i {
                border: solid #ffff;
                border-width: 0 2px 2px 0;
                display: inline-block;
                padding: 2px;
                margin: 0px 0px 11px 6px;
                transform: rotate(-135deg);
                -webkit-transform: rotate(-135deg);
            }
        }  
        h5{
            background: #005586;
            padding: 0px;
            width: 16px;
            border-radius: 50%;
            height: 16px;
            margin: 5px 0px 0px 11px;
            cursor: pointer;
            i {
                border: solid #ffff;
                border-width: 0 2px 2px 0;
                display: inline-block;
                padding: 2px;
                margin: 0px 0px 11px 5px;;
                transform: rotate(45deg);
                -webkit-transform: rotate(45deg);
            }
        }
    }
    .order-details-wrapper{
      border: 1px solid #ececee;
      border-top: 0;
      border-bottom: 0;
        td{
            border: none;
        }
        h6{
            font-size: 13px;
            font-weight: bold;
        }
        p{
            font-size: 14px;
            margin-top: 10px;
        }
        .print-tag-style{
            border: 1px solid #E5E5E5;
            padding: 5px 15px 5px 15px;
            border-radius: 5px;
            background: linear-gradient(90deg, #55C416 0%, #367910 100%);
            color: #fff;
        }
    }    
`;

export const PaidDateModal = styled.div`
    .file-input-wrapper{
      width: 200px !important;
    }
    p{
      font-weight: bold;
      font-size: 20px;
    } 
    .buttonStyle{
      background: #61ae24;
      border: none;
      border-radius: 5px;
      width: 75px;
      padding: 8px;

    }
    .cancel-button{
      background: #cccbcb;
      border: none;
      border-radius: 5px;
      margin-right: 10px;
      width: 75px;
      padding: 8px;
    }
`
